module.exports = __webpack_public_path__ + "img/default-avatar.10fd0b46.svg";